<div [formGroup]="form" *ngIf="form && form.get('FieldsRules')">
  <div formArrayName="FieldsRules">

    <div class="panel panel-default" *ngFor="let fieldsRule of form.controls.FieldsRules.controls; let i=index"
      [formGroupName]="i">
      <div class="panel-heading clearfix pointer" data-toggle="collapse" [attr.data-target]="'#collPnRule' + i"
        (click)="collPnRule[i] = !collPnRule[i]">
        <h5 class="panel-title">
          <i class="fas fa-pencil-ruler"></i>
          <strong>{{fieldsNames[fieldsRule.get('FieldCode').value]|translate}}</strong>
          <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPnRule[i], 'fa-caret-up': !collPnRule[i]}"></i>
        </h5>
      </div>
      <div [id]="'collPnRule' + i" class="panel-body no-horizontal-padding collapse in">

        <div class="form-group">
          <div class="col-sm-6">
            <div class="full-width inline-flex">
              <!-- Regras -->
              <mat-form-field class="full-width" *ngIf="rules[fieldsRule.get('FieldCode').value]">
                <mat-label>{{ 'DESCRIPTION_RULES'|translate }}</mat-label>
                <mat-select formControlName="FieldRule"
                  (selectionChange)="onChangeRule(i)">
                  <mat-option></mat-option>
                  <mat-option *ngFor="let item of rules[fieldsRule.get('FieldCode').value]" [value]="item.ID">
                    {{item.Name}}</mat-option>
                </mat-select>
              </mat-form-field>
              <button type="button" class="btn btn-default pull-right" [title]="'RULE_DESCRIPTION'|translate"
                (click)="showNotes('RULE_DESCRIPTION', fieldsRule.get('RuleNotes').value)"
                [disabled]="!fieldsRule.get('RuleNotes').value">
                <i class="fas fa-align-left"></i>
              </button>
            </div>
            <mat-error *ngIf="formErrors.FieldsRules[i].FieldRule" class="font75per">
              {{formErrors.FieldsRules[i].FieldRule}}
            </mat-error>
          </div>

          <!-- Field -->
          <div class="col-sm-6" formArrayName="Levels">
            <div class="form-group" *ngFor="let level of fieldsRule.controls.Levels.controls; let j=index"
              [formGroupName]="j">
              <div class="col-sm-12">

                <app-generic-field [form]="level" [fieldConfig]="level.get('FieldConfig').value" [parentIndex]="i"
                  (onFieldChange)="onFieldChange($event)" [uppercaseText]="uppercaseText">
                </app-generic-field>

                <mat-error *ngIf="formErrors.FieldsRules[i].Levels[j][level.get('FieldCode').value]" class="font75per">
                  {{formErrors.FieldsRules[i].Levels[j][level.get('FieldCode').value]}}
                </mat-error>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>